import { Injectable } from '@angular/core';
import { catchError } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';
import { HttpEvent, HttpRequest, HttpHandler, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';

import { SecurityService } from './security.service';
import { environment } from 'src/environments/environment';

@Injectable()
export class SecurityInterceptor implements HttpInterceptor {
  constructor(private securityService: SecurityService) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (this.securityService.valid) {
      const { credential } = this.securityService;
      const headers = {};

      if (credential?.accessToken) {
        headers['Authorization'] = `Bearer ${credential.accessToken}`;
      }

      if (credential?.userId) {
        headers['X-User-Id'] = credential.userId;
      }

      if (credential?.profile) {
        headers['X-User-Role'] = credential.profile;
      }

      request = request.clone({
        setHeaders: { ...headers },
      });
    }

    return next.handle(request).pipe(
      catchError((response: HttpErrorResponse): Observable<HttpEvent<any>> => throwError(response))
    );
  }
}
